import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { Button } from '../../components/ui/Button.jsx';
import { Modal } from '../../components/ui/Modal.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { financeApi } from '../../services/financeApi.js';

const empty = () => ({ partyType: 'CUSTOMER', partyName: '', amount: '', description: '' });

export function DownPaymentModal({ open, onClose }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [form, setForm] = useState(empty);
  const [error, setError] = useState(null);

  useEffect(() => { if (open) { setForm(empty()); setError(null); } }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = useMutation({
    mutationFn: (body) => financeApi.createDownPayment(body),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['finance', 'down-payments'] }); onClose(); },
    onError: (err) => setError(err?.message || t('common.loadError')),
  });

  function submit(e) {
    e.preventDefault();
    setError(null);
    if (!form.partyName.trim() || !form.amount || Number(form.amount) <= 0) { setError(t('dp.error.required')); return; }
    save.mutate({ partyType: form.partyType, partyName: form.partyName.trim(), amount: Number(form.amount), description: form.description || null });
  }

  return (
    <Modal open={open} onClose={onClose} title={t('dp.modal.title')}
      footer={<><Button variant="ghost" onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="primary" onClick={submit} disabled={save.isPending}>{save.isPending ? `${t('common.save')}…` : t('common.save')}</Button></>}>
      <form onSubmit={submit} className="form-stack">
        <div className="field-row">
          <label className="field" style={{ maxWidth: 180 }}><span className="field-label">{t('dp.field.partyType')}</span>
            <select className="input" value={form.partyType} onChange={set('partyType')}>
              <option value="CUSTOMER">{t('dp.partyType.CUSTOMER')}</option>
              <option value="VENDOR">{t('dp.partyType.VENDOR')}</option>
            </select>
          </label>
          <label className="field"><span className="field-label">{t('dp.field.party')}</span>
            <input className="input" value={form.partyName} onChange={set('partyName')} required />
          </label>
        </div>
        <label className="field" style={{ maxWidth: 200 }}><span className="field-label">{t('dp.col.amount')}</span>
          <input className="input num" type="number" min="0.01" step="0.01" value={form.amount} onChange={set('amount')} required />
        </label>
        <label className="field"><span className="field-label">{t('dp.field.description')}</span>
          <input className="input" value={form.description} onChange={set('description')} />
        </label>
        {error && <div className="alert danger">{error}</div>}
      </form>
    </Modal>
  );
}
